import React, { useState } from "react";
import Pending from "./Pending";
import Purchased from "./Purchased";
import Received from "./Received";

// Approved (user, 2026-10-29): the Pending list -- purchasing pending, not
// the WO status -- for work orders whose status is Approved. After Pending,
// and the tab the page opens on.
const tabs = [
  { id: "pending", label: "Pending" },
  { id: "approved", label: "Approved" },
  { id: "purchased", label: "Purchased" },
  { id: "received", label: "Received" },
];

export default function Purchasing() {
  const [activeTab, setActiveTab] = useState("approved");

  const renderTab = () => {
    switch (activeTab) {
      case "pending":
        return <Pending />;
      case "purchased":
        return <Purchased />;
      case "received":
        return <Received />;
      case "approved":
        return <Pending key="approved" approved />;
      default:
        return <Pending />;
    }
  };

  return (
    <div className="" style={{ marginLeft: 260, height: "100vh" }}>
      {/*   Tabs
       ********************************************* */}
      <div className="mb-3 bg-white px-3 py-2">
        <div className="btn-group">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`btn btn-sm ${
                activeTab === tab.id ? "btn-primary" : ""
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/*   Tab Content
       ********************************************* */}
      <div className="px-2">{renderTab()}</div>
    </div>
  );
}
